module.exports = __webpack_public_path__ + "static/img/PetVision-LogoBlue-banner.a3be031.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PetVision-LogoBlue-banner.svg
// module id = ZIy4
// module chunks = 1